export default __webpack_public_path__ + "static/media/icon-cell.b2b22552.svg";